import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import IconNew from "components/elements/iconsSize";
import Button, { THEMES as themes } from "components/elements/Button";
import Text, { TYPES as types, SIZES as sizes, TextWithIcon } from 'components/elements/Text'
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ResourcesModalContent from "./components/ResourcesModalContent";
import FeaturesModalContent from "./components/FeaturesModalContent";
import SignInUpModal from "components/elements/SignInUpModal";
import LinksGroup from "./components/LinksGroup";
import {linkGroups as featuresLinks} from './components/FeaturesModalContent'

import "./index.scss";

const NavigationBar = ({ isMobile }) => {
    const location = useLocation()
    const [isOpenSignModal, setIsOpenSignModal] = React.useState(false)
    const [type, setType] = React.useState('login')
    const [isOpenResources, setIsOpenResources] = React.useState(false)
    const [isOpenFeatures, setIsOpenFeatures] = React.useState(false)
    const navigate = useNavigate()
    const [isOpenMobileNavbar, setIsOpenMobileNavbar] = useState(false)

    useEffect(() => {
        if (location.state && location.state.isFromReset) {
            setIsOpenSignModal(true)
            navigate(".", { isFromReset: false });
        }
        if (location.state && location.state.isOpenRegister) {
            setIsOpenSignModal(true)
            setType('signup')
            navigate(".", { isOpenRegister: false });
        }
        if(location.state && location.state.isOpenFeatures) {
            setIsOpenFeatures(true)
            if(isMobile) {
                setIsOpenMobileNavbar(true)
            }
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
            navigate(".", { isOpenFeatures: false });
        }
        if(location.state && location.state.isOpenResources) {
            setIsOpenResources(true)
            // setIsOpenModal(true)
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
            navigate(".", { isOpenResources: false });
        }
    }, [location, navigate, isMobile])

    useEffect(() => {
        if(isMobile) {
            if(isOpenMobileNavbar) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = 'visible'
            }
        }
    }, [isOpenMobileNavbar, isMobile])

    const handleNavigateToLogin = () => {
        navigate('/login')
    }

    const handleNavigateToSignUp = () => {
        navigate('/signup');
    }


    if(isMobile) {
        return (
            <div className="flex py-[22px] px-4 w-full items-center justify-between select-none">
            <div className="home__modal__logo">
                <NavLink
                    to='/'
                    onClick={() => {
                        if(isOpenMobileNavbar) {
                            setIsOpenMobileNavbar(false)
                        }
                    }}
                >
                        <IconNew name="MiestroLogo" />
                </NavLink>
            </div>
            {isOpenSignModal && (
                <SignInUpModal
                    closeModal={() => {
                        setIsOpenSignModal(false)
                    }}
                    onSignUp={() => {
                        setType('signup')
                    }}
                    onSignin={() => {
                        setType('login')
                    }}
                    onForgetPassword={() => {
                        setType('password')
                    }}
                    type={type}
                />
            )}
            <div
                className="flex flex-col gap-[6px] cursor-pointer"
                role="presentation"
                onClick={() => setIsOpenMobileNavbar(true)}
            >
                <div className="home__icon__line" style={{ width: "18px" }} />
                <div className="home__icon__line" style={{ width: "8px" }} />
                <div className="home__icon__line" style={{ width: "13px" }} />
            </div>
            <div
                className="mobile__navigation__modal overflow-y-auto pb-4"
                style={{ right: isOpenMobileNavbar ? "0%" : "-100%" }}
            >
                <div className="flex flex-col px-4">
                    <div className="flex w-full justify-between items-center py-5">
                        <div />
                        <div
                            className="flex items-center cursor-pointer"
                            role="presentation"
                            onClick={() => setIsOpenMobileNavbar(false)}
                        >
                            <IconNew name="ModalClose" />
                        </div>
                    </div>
                    <div className="flex px-4 flex-col items-center justify-center mt-12">
                        <LinksGroup
                            title="Features"
                            links={ function() {
                                let res = []
                                featuresLinks.forEach(item => {
                                    res = [...res, ...item]
                                })
                                return res
                            }() }
                            sublink="features"
                            iconName="FeatureModal"
                            iconDivClassName="absolute top-[-30px] left-0 links_group_icon"
                            closeNavBar={ () => setIsOpenMobileNavbar(false) }
                            isOpenGroup={ isOpenFeatures }
                        />
                        <NavLink
                            to='/how-works'
                            onClick={ () => setIsOpenMobileNavbar(false) }
                        >
                            <Text
                                inner="How it Works"
                                type={types.medium150}
                                size={sizes.medium}
                                className="cursor-pointer my-4"
                            />
                        </NavLink>
                        <LinksGroup
                            title="Resources"
                            links={ [
                                {
                                    link: 'https://miestrouniversity.miestro.com/',
                                    label: 'Miestro University',
                                    isOutside: true
                                },
                                {
                                    link: 'https://www.facebook.com/groups/miestro',
                                    label: 'Facebook Community',
                                    isOutside: true
                                },
                                {
                                    link: 'demo',
                                    label: 'Demo',
                                },
                                {
                                    link: 'https://blog.miestro.com/',
                                    label: 'Blog',
                                    isOutside: true
                                },
                                {
                                    link: 'https://training.miestro.com/resources',
                                    label: 'Training',
                                    isOutside: true
                                },
                            ] }
                            closeNavBar={ () => setIsOpenMobileNavbar(false) }
                            isOpenGroup={ isOpenResources }
                        />
                        <NavLink
                            to='/pricing'
                            onClick={ () => setIsOpenMobileNavbar(false) }
                        >
                            <Text
                                inner="Pricing"
                                type={types.medium150}
                                size={sizes.medium}
                                className="cursor-pointer my-4"
                            />
                        </NavLink>
                        <a
                            href="https://support.miestro.com"
                            target="_blank" rel="noreferrer"
                            onClick={ () => setIsOpenMobileNavbar(false) }
                        >
                            <Text
                                inner="Help"
                                className="cursor-pointer my-4"
                                type={types.medium150}
                                size={sizes.medium}
                            />
                        </a>
                        <div className="flex flex-col gap-3 mt-6 w-full">
                            <Button
                                theme={themes.secondary}
                                className="w-full"
                                onClick={() => {setIsOpenMobileNavbar(false); handleNavigateToLogin();}}
                                style={{ padding: "12px 24px", width: '100%' }}
                                text="Login"
                            />
                            <Button
                                theme={themes.primary}
                                onClick={() => {setIsOpenMobileNavbar(false); handleNavigateToSignUp();}}
                                style={{ padding: "12px 24px", width: '100%' }}
                                text="Try For Free"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }



    return (
        <>

            <div className={`resoucres__modal${isOpenResources ? ' resoucres__modal__open' : ''}`}>
                {
                    isOpenResources && (
                        <ResourcesModalContent  onClose={()=>setIsOpenResources(false)}/>
                    )
                }
            </div>
            <div className={`resoucres__modal${isOpenFeatures ? ' resoucres__modal__open' : ''}`}>
                <FeaturesModalContent onClose={()=>setIsOpenFeatures(false)}/>
            </div>
            {(isOpenFeatures || isOpenResources) && (
                <div className="resoucres__modal__close"
                    role="presentation"
                    onClick={() => {
                        setIsOpenFeatures(false)
                        setIsOpenResources(false)
                    }}
                ></div>
            )}
            <div className="flex align-middle navigation justify-between w-full  py-[20px] container">
                <div
                    className="flex align-middle items-center z-[100]"
                    role="presentation"
                    onClick={() => {
                        setIsOpenFeatures(false)
                        setIsOpenResources(false)
                    }}
                 >
                    <NavLink to='/'>
                        <IconNew name="MiestroLogo" />
                    </NavLink>
                </div>
                <div className="flex align-middle gap-[56px] navbar">
                    <div className={`relative flex ${isOpenFeatures ? ' navbar__active' : ''}`}>
                        <TextWithIcon
                            inner="Features"
                            type={types.medium150}
                            generalStyles={{ cursor: 'pointer' }}
                            size={sizes.medium}
                            onClick={() => {
                                setIsOpenFeatures(!isOpenFeatures)
                                setIsOpenResources(false)
                            }}
                            iconProps={{
                                style: { transform: `rotate(${!isOpenFeatures ? 180 : 0}deg)`, transition: '0.3s easy' }
                            }}
                            iconName="ResoucresDropDown"
                            isIconRight={true}
                            className={`cursor-pointer`}
                        />
                    </div>
                    <NavLink to='/how-works'>
                        <Text
                            inner="How it Works"
                            type={types.medium150}
                            size={sizes.medium}
                            className="cursor-pointer"
                            onClick={ () => {
                                setIsOpenResources(false)
                                setIsOpenFeatures(false)
                            }}
                        />
                    </NavLink>
                    <div className={`relative flex ${isOpenResources ? ' navbar__active' : ''}`}>
                        <TextWithIcon
                            inner="Resources"
                            type={types.medium150}
                            generalStyles={{ cursor: 'pointer' }}
                            size={sizes.medium}
                            onClick={() => {
                                setIsOpenResources(!isOpenResources)
                                setIsOpenFeatures(false)
                            }
                            }
                            iconProps={{
                                style: { transform: `rotate(${!isOpenResources ? 180 : 0}deg)`, transition: '0.3s easy' }
                            }}
                            iconName="ResoucresDropDown"
                            isIconRight={true}
                            className="cursor-pointer"
                        />
                    </div>
                    <NavLink to='/pricing'>
                        <Text
                            inner="Pricing"
                            type={types.medium150}
                            size={sizes.medium}
                            className="cursor-pointer"
                            onClick={ () => {
                                setIsOpenResources(false)
                                setIsOpenFeatures(false)
                            }}
                        />
                    </NavLink>
                    <a
                        href="https://support.miestro.com"
                        target="_blank" rel="noreferrer"
                    >
                        <Text
                            inner="Help"
                            className="cursor-pointer"
                            type={types.medium150}
                            size={sizes.medium}
                            onClick={ () => {
                                setIsOpenResources(false)
                                setIsOpenFeatures(false)
                            }}
                        />
                    </a>
                </div>
                <div className="flex gap-4 z-[100]">
                    <Button
                        theme={themes.secondary}
                        onClick={handleNavigateToLogin}
                        style={{ padding: "12px 24px" }}
                        text="Login"
                    />
                    <Button
                        theme={themes.primary}
                        onClick={handleNavigateToSignUp}
                        style={{ padding: "12px 24px" }}
                        text="Try For Free"
                    />
                </div>
            </div>
        </>
    );
};

NavigationBar.propTypes = {
    isMobile: PropTypes.bool
};

export default NavigationBar;
